class exports.PopulationDialog extends FullPageHandler

    init: () ->
        @layoutUrl = 'backend/portal/weightings/population/load-layout'
        @saveUrl = 'backend/portal/weightings/population/save'

        @createDialog()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            @openDialog()
            return

        self = this

        @dialog.find('input[type="checkbox"]').bind 'change', () ->
            inputs = $(this).closest('.component-container').find('select')

            if $(this).is(':checked')
                inputs.removeAttr('disabled')
            else
                inputs.attr('disabled', 'disabled')

        @dialog.find('input[type="checkbox"]').trigger('change')

        @dialog.find('.cancel-btn').removeAttr('data-dismiss').bind 'click', () =>
            @refresh()

        @dialog.find('.save-btn').bind 'click', () =>
            @save('Saving population components...')

        #if on ipad access through click
        if /iPad/i.test(navigator.userAgent)
            @dialog.find('.info-popover').clickover
                html: true
                container: '#bs2-container'
        #else hover
        else
            @dialog.find('.info-popover').clickover
                html: true
                container: '#bs2-container'
                trigger: 'hover'

        @openDialog()
